import { Component, OnInit } from '@angular/core';
import { VenueService } from '../../service/venue/venue.service';
import { Venue } from '../../class/venue';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-venues',
  templateUrl: './venues.component.html',
  styleUrls: ['./venues.component.scss']
})
export class VenuesComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public venues: Venue[];
    public selectVenue: Venue;
    public venueID: Number = 0;
    public modNew = false;
    public modView = false;
    public openVenue = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    constructor(
        public venueService: VenueService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) { }

    ngOnInit() {
        //this.getVenues();
        this.page = 1;
        this.per_page = 10;
    }

    public loadVenuesLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        this.getVenues(event.globalFilter);
    }

    public getVenues(query?: string) {
        this.venueService.getVenue(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.venues = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newVenue() {
        this.modNew = !this.modNew;
        this.selectVenue = null;
    }

    public savedVenue(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectVenue = null;
        this.modNew = false;
        this.getVenues();
    }

    public cancelVenue (res) {
        this.selectVenue = null;
        this.modNew = false;
        this.modView = false;
        this.getVenues();
    }

    public edit(venue: Venue) {
        this.modNew = true;
        this.selectVenue = venue;
        this.getVenues();
    }

    public view(venue: Venue) {
        this.openVenue = true;
        this.selectVenue = venue;
        this.venueID = venue.id;
        this.modView = true;
    }

    public deleteDialog(venue: Venue) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(venue);
            }
        });
    }

    public delete(venue: Venue) {
        this.venueService.deleteVenue(venue.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getVenues();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeVenue(venue: Venue) {
        this.putVenue(venue);
    }

    public putVenue(values: Venue) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.venueService.updateVenue(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/venues/venues.component.ts